import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'core-js';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'antd/dist/antd.css';

const checkVersion = () => {
    if (process.env.__VERSION__ !== localStorage.getItem('appVersion') && process.env.NODE_ENV === 'production') {
      localStorage.clear();
      sessionStorage.clear();
      localStorage.setItem('appVersion', process.env.__VERSION__);
      window.location.href = `${process.env.DOMAIN}/#/login`;
      window.location.reload();
    }
  };

  checkVersion();

ReactDOM.render(<App />, document.getElementById('root'));
